/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export { ApprovalsAppCommandBarContainer as ApprovalsAppCommandBar } from './ApprovalsAppCommandBar.container';
